import { Fragment } from "react/jsx-runtime";
import {
  ROUTE_KEYS,
  ROUTES,
} from "../../../../_configuration/routing/constants";
import { parseType } from "../../../../services/form/functions";
import {
  formatFormTypeByConditional,
} from "../../../../util/functions";
import IconLinkCell from "../Renders/Cells/IconLink";
import { Mui, MuiIcons } from "@osu/react-ui";
import { APPLICATION_NAME, FORM_STATUS_LABELS } from "../../../../util/constants";
const formsLink = ROUTES[ROUTE_KEYS.FORMS].path;

const parsePath = ({ row = {} }) => {
    const { id: formId, sk } = row;
    const type =parseType(row)
    if(!type || !sk) return '';
    const identifierFromSk= (sk || "")?.split("#")?.[1];
    const id = formId || identifierFromSk;

    const to = (type && id) ? `${formsLink}/${type}/${id}` : '';

    return to
  }

export const renderCell = {
  actions: ({ row = {}, formattedValue, value, field, onFormPathClick }) => {
    const email = row?.email || "";
    const submitter = row?.nameN || email || row?.emplid || "";
    const emailTitle = "E-mail " + (submitter || "Submitter")
    const formLink = parsePath({ row, formattedValue, value, field })
    let emailTo = ''
    if(email && email.includes("@")) {
      emailTo += `mailto:${email}`
      let subject = APPLICATION_NAME
      if(subject && row?.foreignSourceName) {
        subject += ` - ${row?.foreignSourceName}`
      }
      if(subject) {
        emailTo += `?subject=${encodeURIComponent(subject)}`
      }
    }
    
    return <Fragment>
      {!!(formLink) && <Mui.Tooltip title="View Form">
        <IconLinkCell Icon={MuiIcons.Description}  to={formLink} onClick={onFormPathClick} />
      </Mui.Tooltip>}
      {!!emailTo && <Mui.Tooltip title={emailTitle}>
        <IconLinkCell Icon={MuiIcons.MailOutline} to={emailTo} />
      </Mui.Tooltip>}
    </Fragment>
  }
};

export const valueFormatter = {
  type: (value, { isRestrictedOrConditional }) => {
    return formatFormTypeByConditional({
      type: value,
      isRestrictedOrConditional
    })
  },
  status: (value) => {
    return FORM_STATUS_LABELS?.[value] || value
  }
};
